import React from "react";

import { Card, Typography, Flex } from "antd";
const { Title } = Typography;

import "./style.scss";
const styleWrapperClass = "floatingCard";

export default function FloatingCard({ title, children, style }) {
  return (
    <div className={styleWrapperClass}>
      <Card style={style}>
        <Flex vertical gap={10}>
          {title && <Title level={3}>{title}</Title>}
          {children}
        </Flex>
      </Card>
    </div>
  );
}
